// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBypZG_J-z7jUcPuPJ_fg7jmc5eaAmIuR8",
    authDomain: "novaclay-fd588.firebaseapp.com", 
    databaseURL: "https://novaclay-fd588.firebaseio.com",
    projectId: "novaclay-fd588",
    storageBucket: "novaclay-fd588.appspot.com",
    messagingSenderId: "752023226129"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts